<template>
  <div class="row">
    <div class="col-12">
      <h4> Nueva Solicitud de Traslado</h4> 
      <hr class="w-100 my-2"/>
    </div>
    <div class="col-2 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        De *
      </p>
      <multiselect 
        v-model="FromWarehouse" 
        :options="fromWarehouseOptions" 
        placeholder="Seleccionar origen"
        :allowEmpty="false"
        :showLabels="false"
        class="small-multiselect"
      />
    </div>
    <div class="col-2 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        A *
      </p>
      <multiselect 
        v-model="ToWarehouse" 
        :options="warehouses || []" 
        label="WarehouseCode" 
        track-by="WarehouseCode"
        placeholder="Almacén de destino"
        :allowEmpty="false"
        :showLabels="false"
        :loading="!warehouses"
        class="small-multiselect"
      />
    </div>
    <div class="col-2 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        Vencimiento *
      </p>
      <flat-picker
        v-model="vencimiento"
        :config="{ allowInput: true }" 
        class="input-group-alternative form-control-sm text-xs datepicker m-0 w-100 " 
        style="cursor:pointer; outline:none;"
        placeholder="Fecha de vencimiento"
      />
    </div>
    <div class="col-3 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        Transporte/Paquetería *
      </p>
      <multiselect 
        v-model="TS_Shipping" 
        :options="TS_ShippingOptions || []" 
        label="Description" 
        track-by="Value"
        placeholder="Transporte/Paquetería"
        :allowEmpty="false"
        :showLabels="false"
        :loading="!TS_ShippingOptions"
        class="small-multiselect"
      />
    </div>
    <div class="col-3 mb-2">
      <p class="text-xs font-weight-bold mb-0">
        # Guía *
      </p>
      <base-input
        v-model="guia" 
        placeholder="# Guía"
        class="m-0"
        inputClasses="input-group-alternative form-control-sm text-xs"
      />
    </div>
    <div class="col-12 mt-3">
      <ag-grid-vue
        ref="agLines" 
        class="ag-theme-alpine"
        style="min-height: 400px; width: 100%; height: 60vh;" 
        v-bind="agLines"
        @gridReady="onGridReady"
        @cellClicked="onCellClicked"
      />
    </div>

    <div class="col-12">
      <hr class="w-100 my-3"/>
      <div class="d-flex justify-content-end">
        <base-button @click="crearST" icon="fa fa-check" type="success" :disabled="!validation">
          Crear Solicitud de Traslado
        </base-button>

      </div>
    </div>
    <Overlay v-if="saving" class="rounded overflow-hidden">
      <base-loader text="Creando Solicitud de Traslado. Por favor espere, esta operación podría demorar." class="mx-4 flex-grow-1"/>
    </Overlay>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import Multiselect from 'vue-multiselect'
import flatPicker from "vue-flatpickr-component";
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue';
import AgGrid from '@/mixins/AgGrid';
import { AG_GRID_LOCALE_ES } from "@ag-grid-community/locale";
import Formats from '@/mixins/Formats';
import AgIcon from '@/components/AgGrid/AgIcon.vue';
import Overlay from '@/components/Overlay.vue';
import BaseLoader from "@/components/BaseLoader.vue";

  export default {
    name: 'NewST',
    mixins: [AgGrid, Formats],
    components: {
      AgGridVue,
      Multiselect,
      flatPicker,
      AgIcon,
      Overlay,
      BaseLoader
    },
    props: {
      selected: {
        type: Array,
        default: () => []
      }
    },
    data(){
      return {
        saving: false,
        warehouses: null,
        TS_ShippingOptions: null,
        TS_Shipping: null,
        FromWarehouse: null,
        fromWarehouseOptions: [
          'AD-CUU', 'AD-MTY', 'AD-GDL', 'AD-QRO',
          'AD-MEX', 'AD-MID', 'AD-EXT', 'AD-DIG'
        ],
        allowedToWarehouses: [
          'CUU-01', 'CUU-02', 'MTY-02', 'GDL-02', 'QRO-02',
          'MEX-02', 'MID-02', 'EXT-01', 'EXT-02', 'DIG-01', 'DIG-02'
        ],
        ToWarehouse: null,
        vencimiento: null,
        guia: null,
        agLines: {
          rowData: null,
          columnDefs: [
            {
              field: "PurchaseOrders/DocumentLines.ItemCode",
              headerName: "Artículo",
              width: 170
            },
            {
              field: "PurchaseOrders/DocumentLines.ItemDescription",
              headerName: "Descripción",
              cellClass: "font-weight-bold",
              width: 300
            },
            {
              field: "PurchaseOrders/DocumentLines.Quantity",
              headerName: "Cantidad",
              type: 'rightAligned',
              valueFormatter: ({ value }) => this.numberFormat(value),
              width: 120
            },
            {
              field: "PurchaseOrders/DocumentLines.UoMCode",
              headerName: "Unidad",
              width: 120
            },
            {
              field: "PurchaseOrders/DocumentLines.U_ProveedorDIOT",
              headerName: "# Tarimas",
              width: 120,
              editable: true,
              valueFormatter: ({value}) => value || 'Seleccionar...',
              cellClass: 'ag-editable-cell',
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: ['FTL', 'LTL'],
                valuePlaceholder: '# Tarimas',
              },
            },
            {
              colId: "remove",
              width: 70,
              minWidth: 70,
              maxWidth: 70,
              cellClass: "text-center ag-clickable-cell",
              cellRendererSelector: () => {
                return {
                  component: "AgIcon",
                  params: {
                    color: "red",
                    icon: "fas fa-trash",
                  },
                };
              },
            },
          ],
          defaultColDef: {
            filter: false,
            suppressHeaderMenuButton: true,
          },
          autoSizeStrategy: {
            type: 'fitGridWidth',
            defaultMinWidth: 100,
          },
          singleClickEdit: true,
          loadingOverlayComponent: "BaseLoader",
          suppressCellFocus: true,
          enableCellTextSelection: true,
          localeText: AG_GRID_LOCALE_ES,
          alwaysShowVerticalScroll: true,
        },
      }
    },
    created(){
      axios.get(`/api/warehouses`)
      .then((result) => {
        this.warehouses = result.data.value.filter(
          w => this.allowedToWarehouses.includes(w.WarehouseCode)
        );
      });
      axios.get(`/api/user_fields/ST_Shipping`)
      .then((response) => {
        this.TS_ShippingOptions = response.data.value[0].ValidValuesMD;
      });
    },
    methods: {
      onGridReady(){
        this.agLines.rowData = [...this.selected];
      },
      onCellClicked({ column, data }) {
        if(column.colId === 'remove'){
          this.agLines.rowData = this.agLines.rowData.filter(x => {
            return !(x["PurchaseOrders/DocumentLines"].LineNum === data["PurchaseOrders/DocumentLines"].LineNum
              && x["PurchaseOrders"].DocNum === data["PurchaseOrders"].DocNum);
          });
        }
      },
      crearST() {
        this.saving = true;
        const stLines = this.agLines.rowData.map((x) => {
          const line = {
            ItemCode: x["PurchaseOrders/DocumentLines"].ItemCode,
            UnitPrice: x["PurchaseOrders/DocumentLines"].UnitPrice,
            Quantity: x["PurchaseOrders/DocumentLines"].Quantity,
            UoMCode: x["PurchaseOrders/DocumentLines"].UoMCode,
            U_FechaConf: x["PurchaseOrders/DocumentLines"].ShipDate,
            U_TS_Marca: x["PurchaseOrders/DocumentLines"].U_TS_Marca,
            U_Issue_ValidatedComment: x["PurchaseOrders/DocumentLines"].U_Issue_ValidatedComment,
            U_ProveedorDIOT: x["PurchaseOrders/DocumentLines"].U_ProveedorDIOT,
          };
          if (['KLM', 'KPZ'].includes(x["PurchaseOrders/DocumentLines"].UoMCode)) {
            line.UoMCode = x["PurchaseOrders/DocumentLines"].UoMCode.substring(1);
            line.Quantity = x["PurchaseOrders/DocumentLines"].Quantity * 1000;
          }
          return line;
        });
  
        const json = {
          CardCode: this.agLines.rowData[0]["PurchaseOrders"].CardCode,
          DueDate: this.vencimiento,
          StockTransferLines: stLines,
          FromWarehouse: this.FromWarehouse,
          ToWarehouse: this.ToWarehouse.WarehouseCode,
          U_Type: "6",
          U_ST_Shipping: this.TS_Shipping.Value,
          U_ST_TrackingNum: this.guia,
          Comments: this.$route.query.ShipmentID,
        };

        console.log("JSON", json);
        axios
          .post(`/api/inventory_transfer_requests`, json)
          .then((response) => {
            console.log("🟪 POST", response.data)
            if(response.data.DocNum){
              this.saveChanges(response.data.DocNum);
            } else if(response.data.sl_err){
              this.$swal("Error", response.data.sl_err.error.message.value, "error");
              this.saving = false;
            } else {
              this.$swal("Error", "Ocurrió un error al crear la ST", "error");
              this.saving = false;
            }
          })
          .catch((e) => {
            console.error("Error", e);
            this.$swal("Error", "Ocurrió un error al crear la ST", "error");
            this.saving = false;
          });
      },

      async getDocLines(docNums){ // Get all DocumentLines of modified DocNums only
        const resGet = [];
        const errGet = [];

        for (const docNum of docNums) { 
          try {
            const res = await axios.get(`/api/purchase_orders/dn/${docNum}`);
            if(res.data.value && res.data.value.length > 0){
              const docLines = res.data.value[0].DocumentLines.filter(x => x.LineStatus === "bost_Open");
              const linesByDocnum = this.agLines.rowData.filter(x => x["PurchaseOrders"].DocNum === docNum)

              linesByDocnum.forEach((line) => {
                const indexDL = docLines.findIndex(x => x.LineNum === line["PurchaseOrders/DocumentLines"].LineNum);
                const {
                  FreeText, Quantity, ShipDate, TaxCode, U_FechaConf, U_FollowUp, U_Issue_ValidatedQty, U_PedimentNum, U_TS_Marca, U_TrackingInfoPO, UnitPrice, WarehouseCode, U_Real_Load_Date, U_Issue_ValidatedComment
                } = line["PurchaseOrders/DocumentLines"];

                docLines[indexDL].FreeText = FreeText;
                docLines[indexDL].Quantity = Quantity;
                docLines[indexDL].ShipDate = ShipDate;
                docLines[indexDL].TaxCode = TaxCode;
                docLines[indexDL].U_FechaConf = U_FechaConf;
                docLines[indexDL].U_FollowUp = U_FollowUp;
                docLines[indexDL].U_Issue_ValidatedQty = U_Issue_ValidatedQty;
                docLines[indexDL].U_PedimentNum = U_PedimentNum;
                docLines[indexDL].U_TS_Marca = U_TS_Marca;
                docLines[indexDL].U_TrackingInfoPO = U_TrackingInfoPO;
                docLines[indexDL].UnitPrice = UnitPrice;
                docLines[indexDL].WarehouseCode = WarehouseCode;
                docLines[indexDL].U_Real_Load_Date = U_Real_Load_Date;
                docLines[indexDL].U_Issue_ValidatedComment = U_Issue_ValidatedComment;
              });

              const json = {
                DocumentLines: {
                  DocumentLines: docLines,
                },
              };
              // Add edited lines to json to patchPO()
              resGet.push({ docEntry: res.data.value[0].DocEntry, json }); 
            }
            else {
              errGet.push(res.data);
            }
          } catch (e) {
            errGet.push(e);
          }
        }
        return {resGet, errGet};
      },
      async patchPO(requests){ // Patch DocumentLines of modified DocNums only
        const resPatch = [];
        const errPatch = [];

        for (const {docEntry, json } of requests) { 
          try {
            const res = await axios.patch(`/api/purchase_orders/${docEntry}`, json);
            if(res.data.result && res.data.result === "OK"){
              resPatch.push(res.data.res);
            }
            else {
              errPatch.push(res.data);
            }
          } catch (e) {
            errPatch.push(e);
          }
        }

        return {resPatch, errPatch};
      },
      saveChanges(stDocNum){
        const uniqueDocNums = [...new Set(this.agLines.rowData.map(x => x["PurchaseOrders"].DocNum))];
        this.getDocLines(uniqueDocNums).then(({ resGet, errGet}) => {

          this.patchPO(resGet).then(({ errPatch }) => {
            if(!errPatch.length && !errGet.length){
              this.$swal(`ST #${stDocNum}`, "Solicitud de Traslado creada correctamente", "success");
              this.$emit("success");
              this.$emit("close");
            } else {
              if(errGet.length) console.error("Get errors", errGet);
              if(errPatch.length) console.error("Patch errors", errPatch);
              
              const msg = [...errGet, ...errPatch].find(e => e.sl_err)
              this.$swal(
                `ST #${stDocNum} creada`, 
                "Hay cambios que no se guardaron correctamente " + (msg && msg.sl_err.error.message.value), 
                "warning"
              );
            }
          })
          .finally(() => {
            this.modified = [];
            this.saving = false;
          });

        });
      },
    },
    computed: {
      validation() {
        return (
          this.FromWarehouse &&
          this.ToWarehouse &&
          this.vencimiento &&
          this.TS_Shipping &&
          this.guia &&
          this.agLines.rowData &&
          this.agLines.rowData.length > 0
        )
      },
    },
  }
</script>

<style>
.ag-editable-cell {
  cursor: pointer;
}
.ag-editable-cell:hover {
  background: #e9ecef;
  border-radius: 0.375rem;
}
.ag-clickable-cell {
  cursor: pointer;
}
.ag-clickable-cell:hover {
  background: #e9ecef;
}
.swal2-container {
  z-index: 9999 !important;
}
.flatpickr-input::placeholder {
  color: #adb5bd !important;
}
</style>